import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentFailure: {
    id: 'components.myaccount.claims.confirmation.paymentAdyen.paymentFailure',
    defaultMessage: 'The payment failed. Please try again.',
  },
  paymentSessionExpired: {
    id: 'components.myaccount.claims.confirmation.paymentAdyen.paymentSessionExpired',
    defaultMessage:
      'Your payment session has expired. Please enter your card details again.',
  },
  cardPaymentMethodName: {
    id: 'components.myaccount.claims.confirmation.paymentAdyen.cardPaymentMethodName',
    defaultMessage: 'Card',
  },
});
